import React from 'react'
import './Alpha.css'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import alpha from "../../assets/img/projects/Learning full.png";
import { Link } from 'react-router-dom';

function Alpha() {
    return (
        <div className='alpha'>
             <Col xs={40} md={30}>
        <Row className="justify-content-center mb-5 mt-3 mr-0 ">
          <Image className="" alt="profile" src={alpha} fluid />
        </Row>
      </Col>
      <Link to="/">
        <span className="button">BACK</span>
      </Link>
        </div>
    )
}

export default Alpha
